import type { WidgetProps } from '@rjsf/utils'
import { MarkdownEditor } from '../../markdown-editor/MarkdownEditor'

export const MarkdownEditorWidget = (props: WidgetProps) => {
  const {
    disabled,
    id,
    onChange,
    readonly,
    value = '',
    schema,
    uiSchema,
    placeholder
  } = props

  const uiOptions =
    (uiSchema &&
      (uiSchema['ui:options'] as { maxLength?: number; charLimit?: number })) ||
    {}
  const charLimit =
    uiOptions.charLimit ?? uiOptions.maxLength ?? schema?.maxLength

  return (
    <MarkdownEditor
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      readonly={readonly}
      charLimit={charLimit}
      placeholder={placeholder}
    />
  )
}
